import { applyOverrides } from "@wix/form-conditions";
import { applyNestedFormOverrides } from "@wix/nested-form-overrides";
import { applyFormOverrides } from "../../services/form-overrides.js";
import { applyNestedForms } from "../../services/apply-nested-forms.js";
function applyAllOverrides(form, values, overrides) {
  return applyNestedForms(
    applyFormOverrides(
      applyNestedFormOverrides(applyOverrides(form, values)),
      overrides ?? {}
    )
  );
}
export {
  applyAllOverrides
};
//# sourceMappingURL=all-overrides.js.map
